export function filterFeeTypes(
  availableFeeTypes: string[],
  objectName: string,
  bankGuarantee?: boolean
) {
  let feesToInclude = []
  switch (objectName) {
    case 'note':
      feesToInclude = [
        'PlatformFee',
        'DistributionFee',
        'OngoingPremium',
        'LifeCompanyFee',
        'AdviceFee'
      ]
      break
    case 'portfolio':
      feesToInclude = [
        'PortfolioManagementFee',
        'DiscretionaryFundManagementFee',
        'StrategyAdviceFee'
      ]
      break
    case 'Delta1':
      feesToInclude = ['Delta1PremiumFee', 'StrategyAdviceFee']
      break
    case 'RiskManaged':
      feesToInclude = ['Delta1PremiumFee', 'RiskControlledPremiumFee', 'StrategyAdviceFee']
      break
    case 'ConstantProportionLeverage':
      feesToInclude = ['Delta1PremiumFee', 'StrategyAdviceFee']
      break
    case 'VolatilityControlLeverage':
      feesToInclude = ['Delta1PremiumFee', 'StrategyAdviceFee']
      break
    case 'ContinuousProtection':
      feesToInclude = bankGuarantee
        ? [
            'Delta1PremiumFee',
            'GapProtectionPremium',
            'RiskControlledPremiumFee',
            'StrategyAdviceFee'
          ]
        : ['Delta1PremiumFee', 'HedgingPremiumFee', 'RiskControlledPremiumFee', 'StrategyAdviceFee']
      break
    case 'TermProtection':
      feesToInclude = bankGuarantee
        ? [
            'Delta1PremiumFee',
            'GapProtectionPremium',
            'RiskControlledPremiumFee',
            'StrategyAdviceFee'
          ]
        : ['Delta1PremiumFee', 'HedgingPremiumFee', 'RiskControlledPremiumFee', 'StrategyAdviceFee']
      break
  }
  return availableFeeTypes.filter(x => feesToInclude.includes(x))
}
